import {
  Mic,
  Languages,
  Video,
  ScanFace,
  Fingerprint,
  ShieldCheck,
  Search,
  Waves,
  FileSearch,
  type LucideIcon,
} from 'lucide-react';

export const serviceIcons: Record<string, LucideIcon> = {
  mic: Mic,
  languages: Languages,
  video: Video,
  'scan-face': ScanFace,
  fingerprint: Fingerprint,
  'shield-check': ShieldCheck,
  search: Search,
  'file-search': FileSearch,
  waves: Waves,
};

export function getServiceIcon(key: string): LucideIcon {
  return serviceIcons[key] ?? Fingerprint;
}
